import { Quote } from "lucide-react";

const CASES = [
  {
    company: "DACH Fintech (Series C)",
    country: "Germany",
    tag: "SAP S/4HANA Migration",
    metric: "8 hires in 32 days",
    quote: "EuroAsia delivered a fully-staffed migration squad faster than our internal team could write JD's. AI-ranked shortlists were 90%+ relevant.",
    author: "VP Engineering",
  },
  {
    company: "Health-tech scale-up",
    country: "Netherlands",
    tag: "AI / ML Platform",
    metric: "12 senior engineers, 9 weeks",
    quote: "We needed senior ML engineers with healthcare experience. The shortlists from EuroAsia were the most curated we've seen in Europe.",
    author: "CTO",
  },
  {
    company: "EU Bank",
    country: "Romania",
    tag: "Nearshore Java squad",
    metric: "Saved €420K vs in-house",
    quote: "A 14-person nearshore Java team, productive from week three, EU contracts and payroll handled end-to-end.",
    author: "Head of Tech Sourcing",
  },
];

export default function CaseStudies() {
  return (
    <section
      id="cases"
      data-testid="case-studies"
      className="py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
            Case Studies
          </div>
          <h2 className="font-display font-bold mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
            Results, not promises.
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {CASES.map((c, i) => (
            <article
              key={i}
              data-testid={`case-${i}`}
              className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 flex flex-col"
            >
              <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold">
                {c.country} · {c.tag}
              </div>
              <div className="mt-3 font-display font-bold text-2xl text-slate-900">
                {c.metric}
              </div>
              <Quote className="w-6 h-6 text-slate-300 mt-6" />
              <p className="mt-3 text-slate-700 leading-relaxed flex-1">
                {c.quote}
              </p>
              <div className="mt-6 pt-4 border-t border-slate-200 text-sm text-slate-500">
                — {c.author}, <span className="text-slate-700">{c.company}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
